import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateWatchConfig,
    getClientGeneralConfig,
    getUserWatchConfig,
    updateUserWatchConfig,
} from '../WatchConfigEndPoint'

export const useUserWatchConfig = (requestorId, userId, enabled = true) => {
    const {watchConfigKeys} = QueryKeyManager(
        QueryKeyTypes.watchConfig,
        requestorId,
    )
    return useQuery({
        queryKey: watchConfigKeys.detailByUser({userId}),
        queryFn: () => getUserWatchConfig(userId),
        enabled: !!requestorId && !!userId,
    })
}

export const useClientWatchConfig = (requestorId, clientId, enabled = true) => {
    const {clientKeys} = QueryKeyManager(QueryKeyTypes.client, requestorId)

    return useQuery({
        queryKey: clientKeys.config({id: clientId}),
        queryFn: () =>
            getClientGeneralConfig(requestorId, clientId, 'watchConfig'),
        enabled: !!requestorId && !!clientId,
    })
}

export const useClientWatchConfigCRUD = (type, requestorId) => {
    const {clientKeys} = QueryKeyManager(QueryKeyTypes.client, requestorId)
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateWatchConfig(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Wacth Config Update Successfully !!',
                    )
                }
            }
        },
    })
}

export const useUserWatchConfigCRUD = (type, requestorId, userId) => {
    const {watchConfigKeys} = QueryKeyManager(
        QueryKeyTypes.watchConfig,
        requestorId,
    )
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? updateUserWatchConfig(requestorId, userId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data && Object.keys(data)?.length > 0) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Wacth Config Update Successfully !!',
                    )
                }
            }
        },
    })
}
